import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { checkAuthentikSession } from '@forwardfinancing/component-library';
import { trackPageView } from '@forwardfinancing/analytics-frontend-library/index';

export class LoginPage extends React.Component {
  componentDidMount() {
    trackPageView({page: 'Login'});

    // A visitor who lands here with an already-active authentik session
    // (stale bookmark, browser back button) is already logged in, so send
    // them to the homepage instead of starting a new login. Otherwise,
    // authentik is the only way to log in now -- bounce straight to it.
    // rd must be a RELATIVE path -- oauth2-proxy discards absolute
    // redirect URLs unless whitelisted, landing users on / instead.
    checkAuthentikSession().then((session) => {
      if (session.active) {
        this.props.history.push('/owner');
      } else {
        window.location.assign('/oauth2/start?rd=' + encodeURIComponent('/owner'));
      }
    });
  }

  render() {
    return (
      <div/>
    );
  }
}

LoginPage.propTypes = {
  history: PropTypes.object
};

export default withRouter(LoginPage);
